import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserPageTitle } from '../shared/constants/browser-page-title.enum';
import { ListsPage } from './lists.page';

const routes: Routes = [
  {
    path: '',
    component: ListsPage,
    data: { title: BrowserPageTitle.lists },
  },
  {
    path: 'search-product-numbers',
    loadChildren: () =>
      import(
        './pages/search-product-numbers/search-product-numbers.module'
      ).then(m => m.SearchProductNumbersPageModule),
  },
  {
    path: 'list-updates',
    loadChildren: () =>
      import('./pages/list-updates/list-updates.module').then(
        m => m.ListUpdatesPageModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ListsPageRoutingModule {}
